import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name:'operatorOptions',
})

export class OperatorFieldPipe implements PipeTransform {

    //between operator not for string elements
    transform(operatorOptions: any, eventValue:any):any {
        if(eventValue && eventValue['type']==='text') {
            return operatorOptions =operatorOptions.filter((elem:any)=>{
                if(elem.value[1].indexOf(2)>= 0){
                    return elem
                }
            })    
        }else if(eventValue && eventValue['type']==='number'){
            return operatorOptions =operatorOptions.filter((elem:any)=>{
                if(elem.value[1].indexOf(0)>= 0){
                    return elem
                }
            })    
        }
        else{
            return operatorOptions;
        }
    }
}